.wrapper {
  --lockup-padding: 12px;

  border-radius: 12px;
  border: 1px solid var(--color-border-primary);
}

.removeButton {
  align-self: start;
}
